import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import DepositAddress from "../DepositAddress.js";
import { returnNetwork } from "../../utils/NetworkFunctions.js";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "50px",
	width: "200px",
	textTransform: "capitalize",
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const DepositAddressStep = ({ cryptoCurrency, network, setAgreement, agreement, address, setAddress, token, title, setStep }) => {
	const [disable, setDisable] = useState(true);

	const nextStep = (e) => {
		setStep(3);
	};
	console.log("token", token);
	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	return (
		<Grid sx={{ width: isMobile ? "100%" : 500 }}>
			<Card>
				<CardContent>
					<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
						{title}
					</Typography>
					<Box sx={{ marginTop: 2 }}>
						<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
							{`${cryptoCurrency} ${returnNetwork(network, cryptoCurrency)} Network`}
						</Typography>
					</Box>
					<DepositAddress
						cryptoCurrency={cryptoCurrency}
						network={network}
						setAgreement={setAgreement}
						agreement={agreement}
						address={address}
						setAddress={setAddress}
						setDisable={setDisable}
						token={token}
					/>
				</CardContent>
				<CardActions>
					<Box sx={{ alignItems: "center", alignContent: "center", textAlign: "center", width: "100%", paddingBottom: 4, paddingTop:2 }}>
						<Button
							size="large"
							variant="extended"
							sx={styleButton}
							onClick={nextStep}
							disabled={disable}
						>
							VERIFY MY DEPOSIT
						</Button>
					</Box>
				</CardActions>
			</Card>
		</Grid>
	);
};

export default DepositAddressStep;
